<nav class="navbar navbar-fixed-top bg-gradient-collier text-white">
  <a class="navbar-brand">
    <img src="/assets/images/logo.png" />

    <span [ngStyle]="{'color': env.production ? 'blue' : 'orange'}">Financial Plan {{globalSettings.budgetYear}} -
      {{globalSettings.actBudLedgerName}}</span>
    <span [ngStyle]="{'color': env.production ? 'blue' : 'orange'}" *ngIf="env.production !== true"> - TEST</span>
  </a>
  <commandHistory></commandHistory>
  <div class="navBarHoverMessage-container">
    <span>{{navBarMessage | async}}</span>
    <div class="navBarHoverMessage">When a property is first loaded into the Revenue Screen, the system checks for existing default data for amenities. This is basically a one time setup process. Please allow this to play out. You can work on other tasks while this is in progress.</div>
</div>
  <tcc-user-status></tcc-user-status>
</nav>

<div class="contentPanel" #container style="position:relative">
  <simpleMenu [isMainMenu]="true" [isExpandable]="true" *ngIf="!hideNav">
    <button type="button" class="btn btn-sm btn-light" title="Home" routerLink="./home" routerLinkActive="active">
      <i class="fa fa-home fa-fw"></i><span class="ml-1 visible-expanded">Home</span>
    </button>
    
    <button type="button" class="btn btn-sm btn-light" title="Revenue Management" routerLink="./revenue"
      routerLinkActive="active">
      <i class="fas fa-dollar-sign fa-fw"></i><span class="ml-1 visible-expanded">Revenue Management</span>
    </button>

    <button type="button" class="btn btn-sm btn-light" title="Reports" routerLink="./reports" routerLinkActive="active">
      <i class="fa fa-file-alt fa-fw"></i><span class="ml-1 visible-expanded">Reports</span>
    </button>
    
    <span *ngIf="(userChangeSubject | async)?.features?.includes('Admin')">
      <button type="button" class="btn btn-sm btn-light" title="Master Calculations" routerLink="./masterCalc"
        routerLinkActive="active">
        <i class="fa fa-calculator fa-fw"></i><span class="ml-1 visible-expanded">Master Calculations</span>
      </button>
      <button type="button" class="btn btn-sm btn-light" title="Targeted Edits" routerLink="./targetedEdit"
        routerLinkActive="active">
        <i class="fa fa-bullseye fa-fw"></i><span class="ml-1 visible-expanded">Targeted Edits</span>
      </button>
      <button type="button" class="btn btn-sm btn-light" title="Batch Export" routerLink="./batchExport"
        routerLinkActive="active">
        <i class="fa fa-plane fa-fw"></i><span class="ml-1 visible-expanded">Batch Export</span>
      </button>
      <button type="button" class="btn btn-sm btn-light" title="User Access" routerLink="./accessMatrix"
        routerLinkActive="active">
        <i class="fa fa-user fa-fw"></i><span class="ml-1 visible-expanded">User Access</span>
      </button>
      <button type="button" class="btn btn-sm btn-light" title="Workflow Admin" routerLink="./workflowAdmin"
        routerLinkActive="active">
        <i class="fa fa-cog fa-fw"></i><span class="ml-1 visible-expanded">Workflow Admin</span>
      </button>
    </span>
    <span
      *ngIf="(userChangeSubject | async)?.features?.includes('Admin') || (userChangeSubject | async)?.features?.includes('Revenue')">
      <button type="button" class="btn btn-sm btn-light" title="Maintenance" routerLink="./maintenance"
        routerLinkActive="active">
        <i class="fa fa-wrench fa-fw"></i><span class="ml-1 visible-expanded">Maintenance</span>
      </button>
    </span>
  </simpleMenu>
  <router-outlet></router-outlet>
</div>

<tcc-preloader *ngIf="state !== 'ready'">Financial Plan</tcc-preloader>
<tcc-notifications [defaultDuration]="10000"></tcc-notifications>